import { createMongoAbility, MongoAbility, RawRuleOf } from "@casl/ability"
import { Action, Subject, TPermission } from "./permissions"

export type AppAbility = MongoAbility<[Action, Subject]>

/** Baut die CASL-Ability aus den effektiven Rechten der Portal-Session (`manage all` greift über die CASL-Wildcards). */
export const defineAbility = (permissions: TPermission[]): AppAbility => {
    // `subjectId` -> Recht gilt nur für die Ressource mit dieser `_id`
    const rules: RawRuleOf<AppAbility>[] = permissions.map((permission) =>
        permission.subjectId
            ? { action: permission.action, subject: permission.subject, conditions: { _id: permission.subjectId } }
            : { action: permission.action, subject: permission.subject }
    )
    return createMongoAbility<AppAbility>(rules)
}

/** Mindestens eines der Rechte (leere Liste = erlaubt). */
export const canAny = (ability: AppAbility, permissions: TPermission[]) =>
    permissions.length === 0 || permissions.some((permission) => ability.can(permission.action, permission.subject))

/** Alle Rechte (leere Liste = erlaubt). */
export const canAll = (ability: AppAbility, permissions: TPermission[]) =>
    permissions.every((permission) => ability.can(permission.action, permission.subject))
